import type { AsyncSequence, Bytes } from "@pdfking/tfunc"

export async function* ResizeBlobs(
  blobs: AsyncSequence<Blob>,
  chunk_size: Bytes = (1024 * 1024 * 30) as Bytes
): AsyncGenerator<Blob> {
  let pending: Blob[] = []
  let totalSize = 0

  for await (const blob of blobs) {
    let remaining = blob

    while (remaining.size > 0) {
      const spaceLeft = chunk_size - totalSize

      if (remaining.size <= spaceLeft) {
        // Fits in current chunk
        pending.push(remaining)
        totalSize += remaining.size
        break
      }

      // Take only what fits in this chunk
      const slice = remaining.slice(0, spaceLeft)
      pending.push(slice)
      totalSize += slice.size

      // Yield exact-size chunk
      yield new Blob(pending)

      // Reset and continue with leftover data
      pending = []
      totalSize = 0
      remaining = remaining.slice(spaceLeft)
    }

    if (totalSize === chunk_size) {
      yield new Blob(pending)
      pending = []
      totalSize = 0
    }
  }

  // Yield remainder
  if (pending.length > 0) {
    yield new Blob(pending)
  }
}
